/**
 * Token Tracking Service
 */
import axios from 'axios';
import { getApiUrl } from '../utils/api';

const API_URL = getApiUrl();

const tokenApi = axios.create({
  baseURL: `${API_URL}/api/token`,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const tokenService = {
  async getTokenInfo(tokenAddress) {
    const response = await tokenApi.get(`/${tokenAddress}/info`);
    return response.data;
  },

  async getHolders(tokenAddress, limit = 50) {
    const response = await tokenApi.get(`/${tokenAddress}/holders`, { params: { limit } });
    return response.data;
  },

  async getTransactions(tokenAddress, limit = 50) {
    const response = await tokenApi.get(`/${tokenAddress}/transactions`, { params: { limit } });
    return response.data;
  },

  async getStats(tokenAddress) {
    const response = await tokenApi.get(`/${tokenAddress}/stats`);
    return response.data;
  },

  async trackToken(tokenAddress) {
    const response = await tokenApi.post('/track', null, { params: { token_address: tokenAddress } });
    return response.data;
  },

  // New methods for real market data
  async getPrice(tokenAddress) {
    const response = await tokenApi.get(`/${tokenAddress}/price`);
    return response.data;
  },

  async getPriceHistory(tokenAddress, days = 7) {
    const response = await tokenApi.get(`/${tokenAddress}/price-history`, { params: { days } });
    return response.data;
  },

  async getTrades(tokenAddress, limit = 50) {
    const response = await tokenApi.get(`/${tokenAddress}/trades`, { params: { limit } });
    return response.data;
  },

  async getEvents(tokenAddress, limit = 50) {
    const response = await tokenApi.get(`/${tokenAddress}/events`, { params: { limit } });
    return response.data;
  },
};

export default tokenService;
